var upload = {

    init: function (dropzoneId, inputId) {
        const dropzone = document.getElementById(dropzoneId);
        const input = document.getElementById(inputId);

        if (!dropzone || !input) return;

        dropzone.addEventListener("dragover", function (e) {
            e.preventDefault();
            dropzone.classList.add('drag-over');
        });

        dropzone.addEventListener("dragleave", function (e) {
            e.preventDefault();
            dropzone.classList.remove('drag-over');
        })

        dropzone.addEventListener("drop", function (e) {
            e.preventDefault();
            if (!e.dataTransfer.files || !e.dataTransfer.files.length) return;

            const dt = new DataTransfer();
            for (const file of e.dataTransfer.files) {
                dt.items.add(file);
            }

            input.files = dt.files;
            input.dispatchEvent(new Event("change", {bubbles: true}));
            dropzone.classList.remove('drag-over');
        });
        dropzone.addEventListener("click", function (e) {
            e.preventDefault();
            input.click();
        })
    }
};